<template>
    <div>
        <!-- 搜索框 -->
        <a-card title="平台管理">
            <!-- <a-button slot="extra" type="primary" @click="handleNewUser">新建平台</a-button> -->
            <a-form layout="inline" @submit="handleSubmit" :form="form">
                <a-form-item label="平台编码">
                    <a-input v-model="searchP.platfromcode" placeholder="请输入平台编码"></a-input>
                </a-form-item>
                <a-form-item label="平台名称">
                    <a-input v-model="searchP.platfromname" placeholder="请输入平台名称"></a-input>
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" htmlType="submit" :key="this.loading.key">筛选</a-button>
                </a-form-item>
                <a-form-item>
                    <a-button type="default" htmlType="submit" :key="this.loading.key" @click="handleSearchReset">重置
                    </a-button>
                </a-form-item>
            </a-form>
        </a-card>

        <!-- 系统列表 -->
        <a-table :columns="columns" :data-source="data" :pagination="false" :loading="tLoading" rowKey="id">
            <span slot="isLogList" slot-scope="text">{{ ['否', '是'][text] }}</span>
            <span slot="roleList" slot-scope="text">{{ selectRole(text) }}</span>
            <template slot="operation" slot-scope="text, record">
                <div class="editable-row-operations">
                    <span>
                        <router-link :to="{ path:'editPlatFrom', query: { id: record.id}}">编辑</router-link>
                    </span>
                    <span>
                        <router-link :to="{ path:'platfromadduser', query: { id: record.id}}">注册平台用户</router-link>
                    </span>
                </div>
            </template>
        </a-table>

        <a-pagination class="my_pagenation" v-model="searchP.page" :total="searchP.total" @change="handlePageChange" show-less-items show-quick-jumper />

    </div>
</template>
<script>
const columns = [
    {
        title: '平台编码',
        dataIndex: 'platfromcode',
        align: 'center',
        width: 160,
    },
    {
        title: '平台名称',
        dataIndex: 'platfromname',
        align: 'left',
        width: 120,
        ellipsises: true,
    },

    {
        title: '默认权限',
        dataIndex: 'defaultrolecode',
        scopedSlots: { customRender: 'roleList' },
        align: 'left',
        width: 120,
    },
    {
        title: '是否需要登录日志',
        dataIndex: 'islog',
        scopedSlots: { customRender: 'isLogList' },
        align: 'left',
        width: 120,
    },
    {
        title: '说明',
        dataIndex: 'remark',
        align: 'left',
        width: 120,
    },
    // {
    //     title: '用户类型',
    //     dataIndex: 'islog',
    //     scopedSlots: { customRender: 'usertype' },
    //     align: 'center',
    //     width: 120,
    // },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        scopedSlots: { customRender: 'operation' },
        width: 120,
    },
]

const data = []

export default {
    data() {
        return {
            form: this.$form.createForm(this),
            data,
            columns,
            searchP: {
                platfromcode: '',
                platfromname: '',
                total: 0,
                pageSize: 0,
                page: undefined,
            },
            tLoading: true,
            roleList: {},
        }
    },
    methods: {
        selectRole(text) {
            let role = this.roleList.filter(function (n) {
                return n.rolecode == text
            })
            if (role.length > 0) {
                return role[0].rolename
            } else {
                return ''
            }
        },
        getSearchRoleConfig() {
            let c_params = {
                platfromcode: '',
                urlparams: false,
            }
            this.tLoading = true
            this.$store
                .dispatch({
                    type: 'ums/searchRoleConfig',
                    params: c_params,
                })
                .then((res) => {
                    console.log(res)
                    this.roleList = res.data.data
                })
        },
        getUserList() {
            let c_params = {
                ...this.searchP,
                urlparams: false,
            }
            this.tLoading = true
            this.$store
                .dispatch({
                    type: 'ums/selectPlatFromConfig',
                    params: c_params,
                })
                .then((res) => {
                    console.log(res)
                    this.tLoading = false
                    let result = res.data.data
                    this.data = result
                    this.searchP.total = result.totalRecords
                    this.searchP.pageSize = result.pageSize
                    this.searchP.page = result.page
                })
        },
        handlePageChange(c_p) {
            this.searchP.page = c_p
            this.updateRoute()
        },
        updateRoute() {
            this.$router.push({
                query: {
                    platfromcode: this.searchP.platfromcode,
                    platfromname: this.searchP.platfromname,
                },
            })
        },
        handleSearchReset() {
            this.searchP.page = 1
            this.searchP.platfromcode = ''
            this.searchP.platfromname = ''
            this.updateRoute()
        },
        handleNewUser() {
            this.$router.push({
                path: 'addPlatFrom',
                // query: {usercode:''}
            })
        },
        handleSubmit(e) {
            e.preventDefault()
            this.searchP.page = 1
            this.updateRoute()
        },
    },

    components: {},
    watch: {
        $route() {
            this.$router.go(0)
        },
    },
    mounted() {
        let query = this.$route.query
        this.searchP.platfromcode = query.platfromcode ? query.platfromcode : ''
        this.searchP.platfromname = query.platfromname ? query.platfromname : ''
        this.searchP.page = query.page ? +query.page : 1
        this.getUserList()
        this.getSearchRoleConfig()
    },
}
</script>
<style scoped>
.editable-row-operations a {
    margin-right: 8px;
}

td {
    padding: 10px 10px;
}
</style>
